import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectIsShowLiveChatFlagOn, selectFeatureFlags } from 'core/userContext';
import { openChat } from 'modules/nav/utils/supportChat';
import { Chat } from 'ui/icons/action/Chat';
import { IconButton } from './IconButton';
import { BUTTON_SIZES, BUTTON_VARIANTS } from './constants';

// to be used specifically for the ada/ zendesk support chat

const BaseChatButton = styled(IconButton)`
  stroke: none;
  && {
    path {
      stroke: none !important;
    }
    :hover {
      path {
        stroke: none !important;
      }
    }
  }
`;

type ChatButtonProps = {
  size?: BUTTON_SIZES;
  /** The type variant of the button */
  variant?: BUTTON_VARIANTS;
};

export const ChatButton = ({
  size = BUTTON_SIZES.MEDIUM,
  variant = BUTTON_VARIANTS.GHOSTINVERTED,
}: ChatButtonProps) => {
  // code for ada/ zendesk support chat
  const { SupportChatAgentWorkspace } = useSelector(selectFeatureFlags);
  const hasSupportLiveChat = useSelector(selectIsShowLiveChatFlagOn);

  return (
    <BaseChatButton
      size={size}
      id="chatSupport"
      data-test="chatSupport"
      onClick={() => openChat(!!hasSupportLiveChat, SupportChatAgentWorkspace)}
      variant={variant}
    >
      <Chat />
    </BaseChatButton>
  );
};
